import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}><g fillRule="evenodd"><circle cx="8" cy="8" r="8" /><path fill="#FFF" d="M3.4 9.169l2.828 2.829 6.364-6.364-.883-.884-5.481 5.48-1.944-1.945z" /></g></svg>);